import React from 'react';
import HeroSection from '../../components/hero-section';
import InfoSection from '../../components/info-section';

const Home = () => (
  <div>
    <HeroSection />
    <InfoSection />
  </div>
);

export default Home;
